var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.994,
    height: 19.653,
    viewBox: "0 0 18.994 19.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.212,121H30.556a.654.654,0,0,0-.556.721v11.534a.655.655,0,0,0,.556.721H46.212a.654.654,0,0,0,.556-.721V121.721A.654.654,0,0,0,46.212,121Zm-11.723,9.371a.575.575,0,1,1-1.113,0V124.6a.575.575,0,1,1,1.113,0Zm1.669.721a.745.745,0,1,1,.556-.721A.655.655,0,0,1,36.158,131.092Zm.556-3.6a.575.575,0,1,1-1.113,0V124.6a.575.575,0,1,1,1.113,0Zm1.669,3.6a.745.745,0,1,1,.556-.721A.655.655,0,0,1,38.384,131.092Zm.556-3.6a.575.575,0,1,1-1.113,0V124.6a.575.575,0,1,1,1.113,0Zm1.669,3.6a.745.745,0,1,1,.556-.721A.655.655,0,0,1,40.61,131.092Zm.556-3.6a.575.575,0,1,1-1.113,0V124.6a.575.575,0,1,1,1.113,0Zm2.226,2.883a.575.575,0,1,1-1.113,0V124.6a.575.575,0,1,1,1.113,0Z",
    transform: "translate(-28.887 -86.661)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.556,33.226A.556.556,0,0,1,0,32.669V31.556A.556.556,0,0,1,.556,31H2.782a.556.556,0,1,1,0,1.113H1.113v.556A.556.556,0,0,1,.556,33.226Z",
    transform: "translate(0 -31)",
    fill: "#697384"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.655 31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.782,33.226a.556.556,0,0,1-.557-.556v-.556h-1.669a.556.556,0,1,1,0-1.113h2.226a.556.556,0,0,1,.556.556v1.113A.556.556,0,0,1,424.782,33.226Z",
    transform: "translate(-422 -31)",
    fill: "#697384"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.655 48.427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.782,423.226h-2.226a.556.556,0,1,1,0-1.113h1.669v-.556a.556.556,0,0,1,1.113,0v1.113A.556.556,0,0,1,424.782,423.226Z",
    transform: "translate(-422 -421)",
    fill: "#697384"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 48.427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.782,423.226H.556A.556.556,0,0,1,0,422.669v-1.113a.556.556,0,0,1,1.113,0v.556H2.782a.556.556,0,1,1,0,1.113Z",
    transform: "translate(0 -421)",
    fill: "#697384"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.78f3bed776f6c73544b894fe607f9d81.svg";
export { ForwardRef as ReactComponent };